import { render } from "./FormGroup.vue?vue&type=template&id=bff67fbe"
const script = {}

import "./FormGroup.vue?vue&type=style&index=0&id=bff67fbe&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__